/* STNDOUT LABEL — storefront behaviour. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------- Header dropdowns ---------------- */
  function closeAllDropdowns(except) {
    $$('[data-dropdown-toggle]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.classList.remove('is-open');
    });
  }
  $$('[data-dropdown-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var item = btn.parentElement;
    function open() { closeAllDropdowns(btn); btn.setAttribute('aria-expanded', 'true'); panel.classList.add('is-open'); }
    function close() { btn.setAttribute('aria-expanded', 'false'); panel.classList.remove('is-open'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      btn.getAttribute('aria-expanded') === 'true' ? close() : open();
    });
    if (window.matchMedia('(hover: hover)').matches) {
      var t;
      item.addEventListener('mouseenter', function () { clearTimeout(t); open(); });
      item.addEventListener('mouseleave', function () { t = setTimeout(close, 150); });
    }
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); btn.focus(); }
      if (e.key === 'ArrowDown' && btn.getAttribute('aria-expanded') === 'true') {
        var first = $('a', panel); if (first) { e.preventDefault(); first.focus(); }
      }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
  });
  document.addEventListener('click', function () { closeAllDropdowns(); });

  /* ---------------- Mobile nav ---------------- */
  var mToggle = $('[data-mobile-toggle]');
  var mNav = $('[data-mobile-nav]');
  if (mToggle && mNav) {
    mToggle.addEventListener('click', function () {
      var open = mToggle.getAttribute('aria-expanded') === 'true';
      mToggle.setAttribute('aria-expanded', String(!open));
      mToggle.textContent = open ? 'menu' : 'close';
      mNav.classList.toggle('is-open', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mNav.classList.contains('is-open')) { mToggle.click(); mToggle.focus(); }
    });
  }

  /* ---------------- Auto-submit selects (localization, sort) ---------------- */
  $$('select[data-autosubmit]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ---------------- Quantity steppers ---------------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('[data-qty-input]', wrap);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    function set(v) {
      v = Math.max(min, isNaN(v) ? min : v);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    $('[data-qty-minus]', wrap).addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    $('[data-qty-plus]', wrap).addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  });

  /* ---------------- Cart page: submit on quantity change ---------------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var cartTimer;
    $$('[data-cart-qty]', cartForm).forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(cartTimer);
        cartTimer = setTimeout(function () {
          cartForm.classList.add('is-loading');
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
          cartForm.appendChild(hidden);
          cartForm.submit();
        }, 400);
      });
    });
  }

  /* ---------------- Money formatting ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------------- Toast ---------------- */
  var toast = $('[data-toast]');
  var toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  /* ---------------- Product page ---------------- */
  var productEl = $('[data-product]');
  if (productEl) {
    var dataEl = $('[data-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var variants = data.variants;
    var form = $('[data-product-form]', productEl);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-button]', form) : null;
    var addLabel = form ? $('[data-add-label]', form) : null;
    var stockMsg = form ? $('[data-stock-message]', form) : null;
    var priceEl = $('[data-product-price]', productEl);
    var errorEl = form ? $('[data-form-error]', form) : null;

    /* Gallery */
    var slides = $$('.sl-gallery__slide', productEl);
    var thumbs = $$('[data-thumb]', productEl);
    var countEl = $('[data-gallery-count]', productEl);
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function showSlide(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function (t, idx) {
        if (idx === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (countEl) countEl.textContent = (current + 1) + ' / ' + slides.length;
    }
    function showMedia(mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) showSlide(idx);
    }
    showSlide(current);
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var prev = $('[data-gallery-prev]', productEl), next = $('[data-gallery-next]', productEl);
    if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
    if (next) next.addEventListener('click', function () { showSlide(current + 1); });
    var galleryMain = $('.sl-gallery__main', productEl);
    if (galleryMain) {
      galleryMain.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') showSlide(current - 1);
        if (e.key === 'ArrowRight') showSlide(current + 1);
      });
      var startX = null;
      galleryMain.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) showSlide(current + (dx < 0 ? 1 : -1));
        startX = null;
      });
    }

    /* Lightbox */
    var zoomBtn = $('[data-zoom]', productEl);
    var lightbox = $('[data-lightbox]');
    if (zoomBtn && lightbox) {
      var lbImg = $('[data-lightbox-img]', lightbox);
      var lbClose = $('[data-lightbox-close]', lightbox);
      function closeLb() { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; zoomBtn.focus(); }
      zoomBtn.addEventListener('click', function () {
        var img = $('img', slides[current]);
        if (!img) return;
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.alt;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        lbClose.focus();
      });
      lbClose.addEventListener('click', closeLb);
      lbImg.addEventListener('click', closeLb);
      lightbox.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Tab') { e.preventDefault(); closeLb(); } });
    }

    /* Variant selection */
    var groups = $$('[data-option-group]', productEl);
    var fixed = $$('[data-option-fixed]', productEl);
    function selectedOptions() {
      var opts = [];
      fixed.forEach(function (f) { opts[parseInt(f.getAttribute('data-option-index'), 10)] = f.value; });
      groups.forEach(function (g) {
        var sel = $('[aria-pressed="true"]', g);
        opts[parseInt(g.getAttribute('data-option-index'), 10)] = sel ? sel.getAttribute('data-option-value') : null;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }
    function markAvailability(opts) {
      groups.forEach(function (g) {
        var gi = parseInt(g.getAttribute('data-option-index'), 10);
        $$('[data-option-value]', g).forEach(function (btn) {
          var test = opts.slice(); test[gi] = btn.getAttribute('data-option-value');
          var v = findVariant(test);
          var ok = v && v.available;
          btn.classList.toggle('is-unavailable', !ok);
          btn.setAttribute('aria-label', btn.getAttribute('data-option-value') + (ok ? '' : ' — ' + (v ? 'sold out' : 'unavailable')));
        });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      var incomplete = opts.some(function (o) { return o === null; });
      var v = incomplete ? null : findVariant(opts);
      markAvailability(opts);
      if (errorEl) errorEl.hidden = true;
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = incomplete ? 'select an option' : window.SL.strings.unavailable;
        if (stockMsg) stockMsg.textContent = incomplete ? '' : 'this combination is unavailable.';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? window.SL.strings.addToCart : window.SL.strings.soldOut;
      if (stockMsg) stockMsg.textContent = v.available ? '' : 'this option is sold out.';
      if (priceEl) {
        var html = '<span class="sl-price">';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="visually-hidden">sale price</span><span class="sl-price__sale">' + formatMoney(v.price, data.moneyFormat) + '</span>' +
                  '<span class="visually-hidden">regular price</span><s class="sl-price__compare">' + formatMoney(v.compare_at_price, data.moneyFormat) + '</s>';
        } else {
          html += '<span>' + formatMoney(v.price, data.moneyFormat) + '</span>';
        }
        var cur = priceEl.querySelector('.sl-currency');
        if (cur) html += cur.outerHTML;
        if (!v.available) html += '<span class="sl-price__soldout">· sold out</span>';
        html += '</span>';
        priceEl.innerHTML = html;
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    groups.forEach(function (g) {
      $$('[data-option-value]', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-option-value]', g).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-selected'); });
          btn.setAttribute('aria-pressed', 'true');
          btn.classList.add('is-selected');
          updateVariant();
        });
      });
    });
    if (groups.length) markAvailability(selectedOptions());

    /* Add to cart via AJAX (falls back to normal form post without JS) */
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var label = addLabel.textContent;
        addBtn.disabled = true;
        addLabel.textContent = 'adding…';
        var fd = new FormData(form);
        fetch(window.SL.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || window.SL.strings.error);
            return fetch(window.SL.routes.cart_url + '.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            showToast(window.SL.strings.added + '<a href="' + window.SL.routes.cart_url + '">view cart</a>');
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () { addBtn.disabled = false; addLabel.textContent = label; });
      });
    }
  }

  /* ---------------- Related products (section rendering) ---------------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (text) {
      var tmp = document.createElement('div');
      tmp.innerHTML = text;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------------- Form validation (contact / creator forms) ---------------- */
  $$('form[data-validate-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var firstBad = null;
      $$('[required]', f).forEach(function (field) {
        var ok = field.value.trim() !== '';
        if (ok && field.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());
        field.setAttribute('aria-invalid', ok ? 'false' : 'true');
        var msg = f.querySelector('[data-error-for="' + field.id + '"]');
        if (msg) {
          msg.hidden = ok;
          if (!ok) field.setAttribute('aria-describedby', msg.id || (msg.id = field.id + '-error'));
        }
        if (!ok && !firstBad) firstBad = field;
      });
      if (firstBad) { e.preventDefault(); firstBad.focus(); }
    });
  });
})();
